'use strict';
var { appendToUrl } = require('../common/urlUtil');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    let pid = $('.product-detail').data('pid');
    return pid;
}

/**
 * Retrieves the quantity that should be added to the cart. As per design, it is always 1
 * @return {string} - 1
 */
function getQuantitySelected() {
    return '1';
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {boolean} attr.values.selected - Flag as to whether the attribute is currently selected
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.selectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');

        if (attrValue.selected) {
            $attrValue.addClass('cc-active');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            const buildSrcSet = (imageSet) => {
                return imageSet.map((url, idx) => {
                    return url + ' ' + ((idx + 1) * 100) + 'w';
                }).join(',');
            };
            $('.js-selected-color')
                .attr('src', attrValue.images.swatch[0].url)
                .attr('srcset', buildSrcSet(attrValue.images.swatch[0].resizedUrls));

            let $colorText = $attrValue.children('.js-color-text');
            if ($colorText) {
                $colorText.removeClass('hidden');
            }
        } else {
            $attrValue.removeClass('cc-active');
            $attrValue.siblings('.selected-assistive-text').empty();
            let $colorText = $attrValue.children('.js-color-text');
            if ($colorText) {
                $colorText.addClass('hidden');
            }
        }

        if (attrValue.url) {
            // Gets the part of the size for remove it (inbetween the 'size=' and the next '&'
            var url = attrValue.url;
            var sizeStartIndex = url.indexOf('_size=');
            if (sizeStartIndex > 0) {
                var sizeEndIndex = sizeStartIndex + 6;
                var partOne = url.substring(0, sizeEndIndex);
                var partTwo = url.substring(sizeEndIndex);
                var eIndex = partTwo && partTwo.length > 0 ? partTwo.indexOf('&') : -1;
                var partTwoMod = '';
                if (eIndex > 0) {
                    partTwoMod = partTwo.substring(eIndex);
                }
                var finalUrl = partOne + partTwoMod;
                $attrValue.attr('data-url', finalUrl);
            } else {
                $attrValue.attr('data-url', attrValue.url);
            }
        } else {
            $attrValue.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        // $attrValue.prop('disabled', !attrValue.selectable);
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.selected - Flag as to whether an attribute is currently selected
 * @param {boolean} attr.values.isOnlyOneLeft - Flag as to whether an attribute has limited availability
 * @param {boolean} attr.values.selectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    let attributeSelector = '[data-attr="' + attr.id + '"]';
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find(attributeSelector + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue
            .prop('disabled', false)
            .removeClass('cc-active')
            .removeClass('cc-request-size');

        if (!attrValue.selectable) {
            $attrValue.prop('disabled', true);
            $attrValue.addClass('cc-request-size');
        }
        if (attrValue.selected) {
            var numberofsizes = $('.js-size-container').data('numberofsizes');
            if (numberofsizes && parseInt(numberofsizes) === 1 && $('.js-size-container') && $('.js-size-container').children() && $('.js-size-container').children().first()) {
                $attrValue.data('value', attrValue.url);
                $attrValue.addClass('cc-active');
                let size = $('.cc-prod-functional-info').length > 0
                    ? $('.cc-prod-functional-info').find('.js-size-value').text()
                    : $('.cc-pdp__content-attributes').find('.js-size-value').text();
                // set size on PDP selector
                $('#js-size-text-default').addClass('hidden');
                $('#js-size-text-selected').removeClass('hidden');
                $('#js-size-text-selected').text(size);
                // set size on PDP sticky selector
                $('#js-sticky-size-text-default').addClass('hidden');
                $('#js-sticky-size-text-selected').removeClass('hidden');
                $('#js-sticky-size-text-selected').text(size);
            } else {
                $attrValue.addClass('cc-active');
            }
        } else {
            $attrValue.data('value', attrValue.url);
        }
        $attrValue.find('.js-limited-availability').addClass('hidden');
        $attrValue.removeClass('col-6 col-md-8');
        $attrValue.addClass('col-12');
        $attrValue.parent().find('.js-check-availability').addClass('hidden');

        if (attrValue.isOnlyOneLeft) {
            $attrValue.find('.js-limited-availability').removeClass('hidden');
        }
        if (attrValue.online) {
            $attrValue.parent('.cc-size-container').removeClass('hidden');
        } else {
            $attrValue.parent('.cc-size-container').addClass('hidden');
        }

        if (!attrValue.selectable) {
            $attrValue.removeClass('col-12');
            $attrValue.addClass('col-6 col-md-8');
            $attrValue.parent().find('.js-check-availability').removeClass('hidden');
            $attrValue.parent().find('.js-check-availability').parent().removeClass('hidden');
        }

        if (attrValue.hideNotifyMeProduct) {
            $attrValue.parent().find('.js-check-availability').parent().addClass('hidden');
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object[]} attrs - Attribute
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    // TODO: rivedere il comportamento
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Updates the images shown in page from response containing images.
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateImages(imgs, $productContainer) {
    const buildSrcSet = (imageSet, prevArrStartIndex) => {
        return imageSet.map((url, idx) => {
            return url + ' ' + ((idx + 1 + prevArrStartIndex) * 200) + 'w';
        }).join(',');
    };
    let $imageContainer = $productContainer.find('.js-image-list');

    // Read the template for the images shown in the list
    const imgTemplate = document.getElementById('image-template').innerHTML;
    for (var i = 0; i < imgs.length; i++) {
        var $imagesDivs = $imageContainer.find('.cc-content-image');
        var singleImage = $imagesDivs.get(i);
        // var $ResizedUrlsFirstSource = (imgs[i].resizedUrls).splice(0, 3); // NEC-3985: left to get rid off small width urls
        // var $ResizedUrlsSecondSource = (imgs[i].resizedUrls);
        var $ResizedUrlsMobileSource = (imgs[i].resizedUrlsMobile);
        var $OriginalSource = (imgs[i].url);
        var $ResizedUrlsSource = (imgs[i].resizedUrls);
        if (singleImage) {
            var $picture = $(singleImage).find('picture');
            var $image = $picture.find('img');
            var $sources = $picture.find('source');
            $sources.eq(0).attr('srcset', $ResizedUrlsMobileSource[1]);
            $sources.eq(1).attr('srcset', $ResizedUrlsMobileSource[2]);
            $sources.eq(2).attr('srcset', $OriginalSource);
            $sources.eq(3).attr('srcset', $ResizedUrlsSource[4]);
            $sources.eq(4).attr('srcset', $ResizedUrlsSource[3]);
            $image.attr('src', imgs[i].url);
            $image.attr('alt', imgs[i].alt + 'image number ' + i + '');
            if ($image.hasClass('lazyload')) {
                $image.removeClass('lazyload');
            }
        } else {
            var cloneImage = $imagesDivs.get(i - 1);
            $(cloneImage).clone().appendTo($imageContainer);
            $imagesDivs = $imageContainer.find('.cc-content-image');
            cloneImage = $imagesDivs.get(i);
            var $picture = $(cloneImage).find('picture');
            var $image = $picture.find('img');
            var $sources = $picture.find('source');
            $sources.eq(0).attr('srcset', $ResizedUrlsMobileSource[1]);
            $sources.eq(1).attr('srcset', $ResizedUrlsMobileSource[2]);
            $sources.eq(2).attr('srcset', $OriginalSource);
            $sources.eq(3).attr('srcset', $ResizedUrlsSource[4]);
            $sources.eq(4).attr('srcset', $ResizedUrlsSource[3]);
            $image.attr('src', imgs[i].url);
            $image.attr('alt', imgs[i].alt + 'image number ' + i + '');
            if ($image.hasClass('lazyload')) {
                $image.removeClass('lazyload');
            }
        }
    }
    var imgLength = $imageContainer.find('.cc-content-image').length;
    if (imgs.length < imgLength) {
        var $imagesOld = $imageContainer.find('.cc-content-image');
        for (var j = (imgLength - 1); j > (imgs.length - 1); j--) {
            var oldimg = $imagesOld.get(j);
            $(oldimg).remove();
        }
    }
}

function updateVideo($productContainer, htmlVideo, position) {
    let $videoContainerVertical = $productContainer.find('.js-image-list').find('.cc-content-video:not(".cc-only-mobile")');
    let $videoContainerHorizontalDesktop = $productContainer.find('.cc-pdp__video-horizontal-desktop');
    let $videoContainerHorizontalMobile = $productContainer.find('.cc-content-video.cc-only-mobile');
    var ImageandVideoContainer = $productContainer.find('.js-image-list');
    if ($videoContainerVertical.length > 0) {
        if (position === 'vertical') {
            $videoContainerVertical.replaceWith(htmlVideo);
        } else {
            $productContainer.find('.js-image-list .cc-content-video').remove();
            var desktopVideo = $(htmlVideo).filter('.cc-pdp__video-horizontal-desktop');
            var mobileVideo = $(htmlVideo).filter('.cc-content-video.cc-only-mobile');
            $(ImageandVideoContainer).append(mobileVideo);
            $(desktopVideo).insertAfter('.cc-pdp__info');
        }
    } else if ($videoContainerHorizontalDesktop.length > 0 || $videoContainerHorizontalMobile.length > 0) {
        if (position === 'vertical') {
            $productContainer.find('.cc-pdp__video-horizontal-desktop').remove();
            $productContainer.find('.cc-content-video.cc-only-mobile').remove();
            $(ImageandVideoContainer).prepend(htmlVideo);
        } else {
            var desktopVideo = $(htmlVideo).filter('.cc-pdp__video-horizontal-desktop');
            var mobileVideo = $(htmlVideo).filter('.cc-content-video.cc-only-mobile');
            $videoContainerHorizontalDesktop.replaceWith(desktopVideo);
            $videoContainerHorizontalMobile.replaceWith(mobileVideo);
        }
    } else {
        if (position === 'vertical') {
            $(ImageandVideoContainer).prepend(htmlVideo);
        } else {
            var desktopVideo = $(htmlVideo).filter('.cc-pdp__video-horizontal-desktop');
            var mobileVideo = $(htmlVideo).filter('.cc-content-video.cc-only-mobile');
            $(ImageandVideoContainer).append(mobileVideo);
            $(desktopVideo).insertAfter('.cc-pdp__info');
        }
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {Object} response.product.price - Price object related to the product
 * @param {Object} response.product.price.html - HTML rendering of the price object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object} response.product.images - Product images
 * @param {Object[]} response.product.images.large - Product images in large format
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {Object} response.resources - Translation object
 * @param {boolean} imagesCanChange - if the images can change
 * @param {jQuery} $productContainer - DOM element for a given product.
 **/
function handleVariantResponse(response, $productContainer, imagesCanChange) {
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
    }

    if (imagesCanChange) {
        // Update primary images
        var primaryImageUrls = response.product.images.large;
        updateImages(primaryImageUrls, $productContainer);
        if (response.product.hasHorizontalVideo) {
            if (response.product.videoH.CLDvideoHURL !== $('.cc-pdp__video-horizontal-desktop .cc-video-hotizontal source').attr('src')) {
                updateVideo($productContainer, response.product.videoCloudinaryPdpHtml, 'horizontal');
            }
        } else if (response.product.hasVerticalVideo) {
            if (response.product.videoV.CLDvideoVURL !== $('.js-image-list .cc-content-video source').attr('src')) {
                updateVideo($productContainer, response.product.videoCloudinaryPdpHtml, 'vertical');
            }
        } else {
            $productContainer.find('.js-image-list .cc-content-video').remove();
            $productContainer.find('.cc-pdp__video-horizontal-desktop').remove();
            $productContainer.find('.cc-content-video.cc-only-mobile').remove();
        }
    }

    // Update pricing
    var $priceSelector = $('.js-prices .js-price', $productContainer).length
        ? $('.js-prices .js-price', $productContainer)
        : $('.js-prices .js-price');
    $priceSelector.replaceWith(response.product.price.html);

    updateAvailability(response, $productContainer);

    // Enable "Add to Cart" button if all required attributes have been selected
    $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
        product: response.product, $productContainer: $productContainer
    }).trigger('product:statusUpdate', response.product);
}

/**
 * updates the url after variation change adding in querystring the color
 * @param {string} query- the querystring containing color info
 */
function updateVariantUrl(query) {
    const colorParam = query.split('&').find(p => p.startsWith('dwvar_') && p.includes('_color='));
    if (!colorParam) return;

    const currentUrl = new URL(window.location.href);
    const pathname = currentUrl.pathname;

    // Replace or add the color param
    const newUrl = new URL(window.location.origin + pathname);
    newUrl.searchParams.set(...colorParam.split('='));

    window.history.replaceState({}, '', newUrl.toString());
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {boolean} imagesCanChange - indicates if the images could change as a result of the selection of the attribute
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, imagesCanChange) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                if (imagesCanChange) {
                    var imgVal = $('#js-pv-image').val();
                    let $imageContainer = $productContainer.find('.js-image-list');
                    $imageContainer.find('.cc-content-image').find('picture source').attr('srcset', imgVal);
                }

                // cites on variation group, checking cites value on color selection
                if (data.product.enableDisclaimerShipment && $('.js-disclaimer-shipment').length) {
                    $('.js-disclaimer-shipment').removeClass('d-none');
                } else if (!$('.js-disclaimer-shipment').hasClass('d-none')) {
                    $('.js-disclaimer-shipment').addClass('d-none');
                }

                // pfas on variation group/variant
                if (data.product.pfas && $('.js-banner-pfas').length) {
                    $('.js-banner-pfas').removeClass('d-none');
                } else if (!$('.js-banner-pfas').hasClass('d-none')) {
                    $('.js-banner-pfas').addClass('d-none');
                }

                // data tags
                if (data.product.Tag) {
                    $('.js-tag-container span', $productContainer).text(data.product.Tag.toUpperCase());
                    $('.js-tag-container', $productContainer).attr('hidden', false);
                } else {
                    $('.js-tag-container', $productContainer).attr('hidden', true);
                    $('.js-tag-container span', $productContainer).text('');
                }
                handleVariantResponse(data, $productContainer, imagesCanChange);
                if (data.queryString) {
                    updateVariantUrl(data.queryString);
                }
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {boolean} imagesCanChange - indicates if the images could change as a result of the selection of the attribute
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelectSizeLook(selectedValueUrl, $productContainer, imagesCanChange) {
    if (selectedValueUrl) {
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                $('.js-product-detail-look').data('pid', data.product.id);
                $('button.add-to-cart').data('disabled', (!data.product.readyToOrder || !data.product.available));

                $.spinner().stop();
                // trigger wishlist update
                $('body').trigger('wishlist:productVariantChanged');
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {boolean} imagesCanChange - indicates if the images could change as a result of the selection of the attribute
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelectLook(selectedValueUrl) {
    if (selectedValueUrl) {
        var url = $('.js-select-single-tile-look').data('href');

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                var pid = data.product.sku;
                var dat = {
                    pid: pid
                };

                $.ajax({
                    url: url,
                    data: dat,
                    method: 'GET',
                    success: function (response) {
                        if (response.stickyBar) {
                            $('.js-sticky-look-container').html(response.stickyBar);
                        }
                    },
                    error: function(err) {
                    }
                });
                // handleVariantResponse(data, $productContainer, imagesCanChange);
                // $('body').trigger('product:afterAttributeSelect',
                //     { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

function performAddToCartCall(addToCartUrl, pid, pidsObj, childProducts, quantity, onSuccess, onError, customFrom) {
    var data = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: childProducts,
        quantity: quantity
    };
    const einsteinHelpers = require('../common/einsteinHelpers');
    var masterPid = $('.js-master-pid').val();
    if (addToCartUrl) {
        $.spinner().start();
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: data,
            success: function (data) {
                // handlePostCartAdd(data);
                $.spinner().stop();
                if (onSuccess != null) {
                    // analytics

                    // get product by pid
                    var totPid = pid;
                    var generalPid;
                    if (data.skuMaster) {
                        generalPid = data.skuMaster;
                    } else if (masterPid) {
                        generalPid = masterPid;
                    } else if (data.productColor) {
                        var split = totPid.split(data.productColor);
                        if (split) {
                            generalPid = split[0];
                        }
                    }

                    if (data && data.cart && data.cart.items) {
                        const addedItem = data.cart.items.filter((i) => { return i.id === pid });
                        if (addedItem) {
                            const addItm = addedItem[0];
                            einsteinHelpers.fireAddToCartActivity({
                                'id': generalPid,
                                'sku': pid,
                                'price': addItm.price.sales ? addItm.price.sales.value : (addItm.price.list ? addItm.price.list.value : 0),
                                'originalPrice': addItm.price.list ? addItm.price.list.value : (addItm.price.sales ? addItm.price.sales.value : 0),
                                'quantity': quantity
                            }, customFrom);
                        }
                    }

                    // rerun initialized function to prevent addToCart before window.onload
                    var checkAnalyticsInit = setInterval(function() {
                        // get product -> js-analytics-impressions-product-initialized prevent minicart elements to be selected
                        var selectorPrefix = '.js-analytics-impressions-product-initialized.js-analytics-click-product-info-';
                        // after categorization by var group, multiple product wish same generalPid exist and previous could be taken sending wrong color to analytics
                        var product = $(selectorPrefix + generalPid + '[data-color="' + data.productColor + '"]');

                        if (product.length <= 0) {
                            // if generalPid and product Color combination not exist trying to extract from pid - size TODO: pid concatenation
                            product = $(selectorPrefix + totPid.substring(0, totPid.length - 2));
                        } else if (product.length > 1) {
                            // it should happen when slick slider active due to multiple slide existence
                            product = $(product[0]);
                        }    

                        if (product.length) {
                            clearInterval(checkAnalyticsInit);
                            if (customFrom) {
                                product.attr('data-sticky', customFrom);
                            }

                            $('body').trigger('analytics:pushAddToCart', product);

                            // END
                            // update live content
                            $('.js-mini-cart-update').text(data.addToCartLiveContent);

                            onSuccess(data);
                        } 

                    }, 100);
                }
            },
            error: function () {
                $.spinner().stop();
                if (onError != null) {
                    onError();
                }
            }
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button.js-color-choice', function (e) {
            // When the user clicks on one color inside the stickybar selection, change the aria-label of the selected color.
            $('.cc-content-thumb-color-sticky').attr("aria-label", $(this).attr("data-accessibility-change"));

            if ($(this).hasClass('js-color-choiche-sticky-look')) {
                attributeSelectLook($(this).attr('data-url'));
            } else {
                e.preventDefault();
                $(document).find('.js-image-list .cc-image').removeClass('lazyload');
                if ($(this).attr('disabled')) {
                    return;
                }
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                attributeSelect($(this).attr('data-url'), $productContainer, true);
                // Reset size on PDP selector
                $('#js-size-text-default').removeClass('hidden');
                $('#js-size-text-selected').addClass('hidden');
                $('#js-size-text-selected').text('');
                // Reset size on PDP sticky selector
                $('#js-sticky-size-text-default').removeClass('hidden');
                $('#js-sticky-size-text-selected').addClass('hidden');
                $('#js-sticky-size-text-selected').text('');
                // 4Gift action url after size select
                var colorSelect = $(this).data('attr-value');
                var productPid = $(document).find('#skuMaster').val();
                var action = $(document).find('#4giftersCheckout').data('action');
                var sizeCode = $(document).find('.js-select-size.cc-active').data('attr-value');
                var SKU = productPid + colorSelect + sizeCode;  // pid concatenation PDP
                $(document).find('#4giftersCheckout').data('action-url', action + SKU.toLowerCase());
            }
        });
    },

    colorAttributeLook: function () {
        $(document).on('click', '[data-attr="color"] button.js-color-choice.js-color-choiche-sticky-look', function (e) {
            window.scrollTo(0, 0);
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect($(this).attr('data-url'), $productContainer, true);
            // Reset size on PDP selector
            $('#js-size-text-default').removeClass('hidden');
            $('#js-size-text-selected').addClass('hidden');
            $('#js-size-text-selected').text('');
            // Reset size on PDP sticky selector
            $('#js-sticky-size-text-default').removeClass('hidden');
            $('#js-sticky-size-text-selected').addClass('hidden');
            $('#js-sticky-size-text-selected').text('');
            // 4Gift action url after size select
            var colorSelect = $(this).data('attr-value');
            var productPid = $(document).find('#skuMaster').val();
            var action = $(document).find('#4giftersCheckout').data('action');
            var sizeCode = $(document).find('.js-select-size.cc-active').data('attr-value');
            var SKU = productPid + colorSelect + sizeCode;  // pid concatenation PDP
            $(document).find('#4giftersCheckout').data('action-url', action + SKU.toLowerCase());
        });
    },

    selectAttribute: function () {
        $(document).on('click', '.js-select-size', function (e) {
            e.preventDefault();
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            if ($(this).closest('.cc-content-size-choice-sticky').hasClass('js-select-size-sticky-look')) {
                attributeSelectSizeLook($(e.currentTarget).data('value'), $productContainer, false);
                $('.js-upload-size').find('.js-size-container').removeClass('cc-active');
                $('.js-upload-size').find('.js-select-size').removeClass('cc-active');
                $(this).addClass('cc-active');
                $(this).parent().addClass('cc-active');
                let size = $(this).children('.js-size-value').text();
                let sizeCode = $(this).data('attr-value');
                $('#js-selected-size').val(sizeCode);
                $('#js-selected-size-to-find').val(sizeCode);
                $('.js-selected-size-socialList').val(sizeCode);
                // set size on PDP selector
                $('#js-size-text-default').addClass('hidden');
                $('#js-size-text-selected').removeClass('hidden');
                $('#js-size-text-selected').text(size);
                // set size on PDP sticky selector
                $('#js-sticky-size-text-default').addClass('hidden');
                $('#js-sticky-size-text-selected').removeClass('hidden');
                $('#js-sticky-size-text-selected').text(size);
                $('.js-sticky-choice-look').each((_idx, el) => {
                    let $el = $(el);
                    $el.removeClass('cc-open');
                    $($el.data('target')).removeClass('cc-open');
                });
                // $productContainer = $(e.currentTarget).closest('.js-sticky-look-container');
                // attributeSelectSizeLook($(e.currentTarget).data('value'), $productContainer, false);
            } else {
                attributeSelect($(e.currentTarget).data('value'), $productContainer, false);
                let size = $(this).children('.js-size-value').text();
                let sizeCode = $(this).data('attr-value');
                $('#js-selected-size').val(sizeCode);
                $('#js-selected-size-to-find').val(sizeCode);
                $('.js-selected-size-socialList').val(sizeCode);
                // set size on PDP selector
                $('#js-size-text-default').addClass('hidden');
                $('#js-size-text-selected').removeClass('hidden');
                $('#js-size-text-selected').text(size);
                // set size on PDP sticky selector
                $('#js-sticky-size-text-default').addClass('hidden');
                $('#js-sticky-size-text-selected').removeClass('hidden');
                $('#js-sticky-size-text-selected').text(size);
                // 4Gift action url after size select
                var colorSelect = $(document).find('.js-color-choice.cc-active').data('attr-value');
                var productPid = $(document).find('#skuMaster').val();
                var action = $(document).find('#4giftersCheckout').data('action');
                var SKU = productPid + colorSelect + sizeCode;  // pid concatenation PDP
                $(document).find('#4giftersCheckout').data('action-url', action + SKU.toLowerCase());
            }
        });
    },

    performAddToCart: function (target) {
        var addToCartUrl;
        var pid;
        var pidsObj;

        $('body').trigger('product:beforeAddToCart', target);

        pid = getPidValue($(target));
        if (!pid) {
            pid = $(target).data('pid');
        };
        addToCartUrl = getAddToCartUrl();
        var childProducts = [];
        var quantity = getQuantitySelected($(target));
        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: childProducts,
            quantity: quantity
        };
        var newStickyAddToCartButton = '';
        if (window.isMobile && $(target).closest('.cc-pdp__info').length) {
            var isStickyTop = $(target).closest('.cc-pdp__info').hasClass('cc-pdp__info--top');
            if (isStickyTop) {
                newStickyAddToCartButton = 'sticky_bar_top_macro';
            }
            var isMicroSticky = $(target).hasClass('js-went-micro-button');
            if (isMicroSticky) {
                newStickyAddToCartButton = 'sticky_bar_top_micro';
                $(target).removeClass('js-went-micro-button');
            }
            if (!isMicroSticky && !isStickyTop) {
                newStickyAddToCartButton = 'sticky_bar_bottom';
            }
        } else {
            newStickyAddToCartButton = $(target).attr('data-sticky');
        }

        $(target).trigger('updateAddToCartFormData', form);

        performAddToCartCall(addToCartUrl, pid, pidsObj, childProducts, quantity, function (resData) {
            miniCartReportingUrl(resData.reportingURL);
            $('body').trigger('product:afterAddToCart', resData);
        }, function() {
            //
        }, newStickyAddToCartButton);
    },

    performAddToCartLook: function(target) {
        var addToCartUrl;
        var pid = $('.js-product-detail-look').data('pid');
        var pidsObj;

        addToCartUrl = getAddToCartUrl();
        var childProducts = [];
        var quantity = 1;
        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: childProducts,
            quantity: quantity
        };
        performAddToCartCall(addToCartUrl, pid, pidsObj, childProducts, quantity, function (resData) {
            miniCartReportingUrl(resData.reportingURL);
            $('body').trigger('product:afterAddToCart', resData);
        }, function() {
            //
        }, $(target).attr('data-sticky'));
    },

    addToCart: function () {
        var t = this;
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            if ($(this).hasClass('js-add-to-cart-sticky-look')) {
                var addToCartUrl;
                var pid = $('.js-product-detail-look').data('pid');
                var pidsObj;

                addToCartUrl = getAddToCartUrl();
                var childProducts = [];
                var quantity = 1;
                var form = {
                    pid: pid,
                    pidsObj: pidsObj,
                    childProducts: childProducts,
                    quantity: quantity
                };
                performAddToCartCall(addToCartUrl, pid, pidsObj, childProducts, quantity, function (resData) {
                    miniCartReportingUrl(resData.reportingURL);
                    $('body').trigger('product:afterAddToCart', resData);
                }, function() {
                    //
                }, $(target).attr('data-sticky'));
            } else {
                t.performAddToCart(this);
            }
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    performAddToCartCall: performAddToCartCall
};
